import React from 'react';
import { Helmet } from 'react-helmet';

export const MetaRobotsContent = (): JSX.Element => (
  <Helmet>
    <meta name='robots' content='noindex, nofollow' />
  </Helmet>
);
